module.exports = __webpack_public_path__ + "img/sf_logo.87905fe5.png";